import 'bootstrap/dist/css/bootstrap.min.css';

const FooterManager = () => {
    return (
        <>
        <footer className="bg-dark text-light py-3 mt-auto">
           <div className="container-fluid">
              <div className="row align-items-center">
      
                  <div className="col-md-6 text-center text-md-start">
                     © Cristian Herrera - Web Developer
                   </div>
              </div>
           </div>
        </footer>
        </>
    )
}


export default FooterManager